import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../../guards/role.guard';
import { Role } from '@models/role.model';
import { PrerequisitesGuard } from '../../guards/prerequisites.guard';
import { PreviewDocViewerGuard } from 'src/app/guards/preview-doc-viewer.guard';
import { DocViewerComponent } from "./doc-viewer.component";

const reviewRoutes: Routes = [
	{
		path: '',
		component: DocViewerComponent,
		canActivate: [PrerequisitesGuard, RoleGuard, PreviewDocViewerGuard],
		data: {roles: [Role.StandardFeatureSet, Role.DocReviewFeatureSet, Role.LimitedFeatureSet], hideLeftMenu: true}
	},
	{
		path: 'access-denied',
		component: DocViewerComponent,
		canActivate: [PrerequisitesGuard, RoleGuard],
		data: {roles: [Role.StandardFeatureSet, Role.DocReviewFeatureSet, Role.LimitedFeatureSet], hideLeftMenu: true}
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(reviewRoutes)
	],
	exports: [
		RouterModule
	]
})
export class DocViewerRoutingModule {
}
